import React from 'react';
import { useRecoilState } from 'recoil';
import {
  SidebarState,
  sidebarStateAll,
  SidebarType,
} from '../../../store/sidebar.state';

const SettingStateDebugPanel: React.FC = () => {
  const [allSidebarStates, setAllSidebarStates] =
    useRecoilState(sidebarStateAll);

  const handleToggle = (sidebar: SidebarType, key: keyof SidebarState) => {
    setAllSidebarStates(prev => ({
      ...prev,
      [sidebar]: {
        ...prev[sidebar],
        [key]: !prev[sidebar][key],
      },
    }));
  };

  const handleResetAll = () => {
    const resetStates = Object.keys(allSidebarStates).reduce(
      (acc, sidebar) => {
        acc[sidebar] = {
          isHidden: false,
          isCollapsed: false,
          isPinned: false,
        };
        return acc;
      },
      {} as Record<string, SidebarState>,
    );

    setAllSidebarStates(resetStates);
  };

  return (
    <div className="p-4">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="font-bold">Sidebar State Debug Panel</h2>
        <button
          className="bg-primary hover:bg-primary-hover text-primary-text rounded px-3 py-1 text-sm transition-colors"
          onClick={handleResetAll}
        >
          Reset All to Default
        </button>
      </div>
      <table className="w-full text-xs">
        <thead>
          <tr>
            <th className="text-left">Sidebar</th>
            <th className="text-left">isHidden</th>
            <th className="text-left">isCollapsed</th>
            <th className="text-left">isPinned</th>
          </tr>
        </thead>
        <tbody>
          {Object.keys(allSidebarStates).map(sidebar => (
            <tr className="border-menu/20 border-b" key={sidebar}>
              <td className="pr-2">{sidebar}</td>
              {(['isHidden', 'isCollapsed', 'isPinned'] as const).map(key => (
                <td className="px-1 py-2" key={key}>
                  <button
                    className={`bg-menu flex h-5 w-5 items-center justify-center rounded p-2 ${allSidebarStates[sidebar][key] ? 'bg-menu-active text-menu-active-text' : 'bg-menu'}`}
                    onClick={() => handleToggle(sidebar, key)}
                  >
                    {allSidebarStates[sidebar][key] ? '✔' : '✗'}
                  </button>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SettingStateDebugPanel;
